import React from "react";
import ExcelJS from "exceljs";
import { Button } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import { useEmailContext } from "../../../context/EmailContext";

const EmailSender = ({
  subject,
  templateName,
  variable,
  sheets,
  includeAttachments,
  fileName = "ReportData.xlsx",
  emailButtonText = "Send Email",
  disabled = true,
}) => {
  const { sendEmail, sendEmailLoading } = useEmailContext();

  const handleSendEmail = async () => {
    const workbook = new ExcelJS.Workbook();

    sheets.forEach((sheet, index) => {
      const worksheet = workbook.addWorksheet(
        sheet.name || `Sheet ${index + 1}`,
      );

      if (sheet.header) {
        worksheet.addRow(sheet.header.map((h) => h.label));
      }

      sheet.data.forEach((row) => {
        worksheet.addRow(sheet.header.map((col) => row[col.key] ?? ""));
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const file = new File([blob], fileName, {
      type: blob.type,
    });

    await sendEmail({
      subject,
      templateName,
      variable,
      attachments: includeAttachments ? file : null,
    });
  };
  return (
    <Button
      variant="outlined"
      color="primary"
      size="medium"
      startIcon={<EmailIcon />}
      onClick={handleSendEmail}
      sx={{
        fontSize: "0.8rem",
        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
        height: "40px",
      }}
      disabled={disabled || sendEmailLoading}
    >
      {emailButtonText}
    </Button>
  );
};

export default EmailSender;
